export default function on(element) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  element.addEventListener.apply(element, args);
  return {
    release: function release() {
      element.removeEventListener.apply(element, args);
      return null;
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/carbon-components/es/globals/js/misc/on.js
// module id = 21
// module chunks = 0